import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_InfoBox = _resolveComponent("InfoBox")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_LanguageSkillList = _resolveComponent("LanguageSkillList")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_confirm_dialog = _resolveComponent("confirm-dialog")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_LanguageSkillRegister = _resolveComponent("LanguageSkillRegister")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_card, { loading: _ctx.dataLoading }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, null, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createTextVNode(" Add Language Skills ")
          ])),
          _: 1
        }),
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InfoBox, { title: "Add Your Languages here! (Include your proficiency level)" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      class: "primary_btn w-100",
                      "prepend-icon": "mdi-plus",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAddOrEdit = true))
                    }, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createTextVNode("Add Language")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_LanguageSkillList, {
              isHiringmanager: _ctx.isHiringmanager,
              isAfterSignUp: _ctx.isAfterSignUp,
              onRemove: _ctx.remove,
              onEdit: _ctx.edit,
              languageSkillList: _ctx.items,
              addLoading: _ctx.addLoading
            }, null, 8, ["isHiringmanager", "isAfterSignUp", "onRemove", "onEdit", "languageSkillList", "addLoading"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_dialog, {
          persistent: "",
          modelValue: _ctx.showRemoveConfirm,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showRemoveConfirm) = $event)),
          onKeydown: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.showRemoveConfirm = false), ["esc"])),
          "max-width": "400px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_confirm_dialog, {
              loading: _ctx.deleteLoading,
              onConfirm: _ctx.confirmDelete,
              onCancel: _cache[1] || (_cache[1] = ($event: any) => {
            _ctx.showRemoveConfirm = false;
            _ctx.deleteLoading = false;
          }),
              message: _ctx.confirmModel
            }, null, 8, ["loading", "onConfirm", "message"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["loading"]),
    (_ctx.showAddOrEdit)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 0,
          modelValue: _ctx.showAddOrEdit,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showAddOrEdit) = $event)),
          "max-width": "1000",
          onKeydown: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.cancel()), ["esc"])),
          persistent: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_LanguageSkillRegister, {
              isHiringmanager: _ctx.isHiringmanager,
              isGettingLanguages: _ctx.isGettingLanguages,
              isAfterSignUp: _ctx.isAfterSignUp,
              editingItem: _ctx.editingItem,
              onSaved: _ctx.saveLanguageSkill,
              addLoading: _ctx.addLoading,
              onCancel: _ctx.cancel
            }, null, 8, ["isHiringmanager", "isGettingLanguages", "isAfterSignUp", "editingItem", "onSaved", "addLoading", "onCancel"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}